import React from "react";
import "./Frame43.css";

function Frame43(props) {
  const { line36, className } = props;

  return (
    <div className={`frame-43 ${className || ""}`}>
      <div className="frame-42">
        <div className="group-138">
          <p className="how-do-i-book-an-appointment poppins-normal-tundora-16px">How do I book an appointment?</p>
        </div>
        <img className="vector-4" src="/img/vector-4@2x.png" />
      </div>
      <img className="line-36" src={line36} />
    </div>
  );
}

export default Frame43;
